import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import { useRef, useState } from "react";
import SearchResults from "../search-results/search-results";
import SearchForm from "./search-form";
import { useSearch } from "./search-context";
import useValidateFormData from "./validation/validator";
import { SearchFieldError, SearchFieldErrors } from "./types";

const SearchOrchestrator = () => {
  const { resetFormData, fraudDtectionConsent } = useSearch();

  const validateForm = useValidateFormData();

  const sectionRef = useRef<HTMLDivElement>(null);

  const [showResults, setShowResults] = useState(false);
  const [isQuickSearch, setIsQuickSearch] = useState(true);
  const [fieldErrors, setFieldErrors] = useState<SearchFieldErrors>({
    claimRefErr: false,
    requiredFieldErr: false,
  });
  const [helperText, setHelperText] = useState<SearchFieldError[]>([]);

  const resetErrors = () => {
    setFieldErrors({ claimRefErr: false, requiredFieldErr: false });
    setHelperText([]);
    setShowResults(false);
  };

  const handleFormReset = () => {
    resetFormData();
    resetErrors();
  };

  const handleSearch = () => {
    resetErrors();
    const { errors, errorsState } = validateForm();

    if (errors.length > 0) {
      if (isQuickSearch) setFieldErrors(errorsState);
      setHelperText(errors);
      return;
    }

    setShowResults(true);

    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const toggleSearchMode = () => {
    setIsQuickSearch((prev) => !prev);
  };

  return (
    <Box width="100%" height="100%">
      <SearchForm
        isQuickSearch={isQuickSearch}
        fieldErrors={fieldErrors}
        helperText={helperText}
        resetErrors={resetErrors}
      >
        <Grid
          size={{ xs: 12 }}
          display="flex"
          justifyContent="flex-end"
          gap={1}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={handleFormReset}
            data-testid="reset-button"
            sx={{ textTransform: "none" }}
          >
            Reset
          </Button>

          <Button
            variant="outlined"
            color="primary"
            onClick={toggleSearchMode}
            data-testid={`toggle-button-${isQuickSearch ? "advanced" : "quick"}-search`}
            sx={{ textTransform: "none" }}
          >
            {isQuickSearch ? "Advanced Search" : "Quick Search"}
          </Button>

          <Button
            variant="contained"
            color="primary"
            disabled={!fraudDtectionConsent}
            onClick={handleSearch}
            data-testid="search-button"
            sx={{ textTransform: "none" }}
          >
            <SearchIcon fontSize="small" sx={{ marginRight: 1 }} />
            Search
          </Button>
        </Grid>
      </SearchForm>
      <div style={{ minHeight: "200px" }} ref={sectionRef}>
        {showResults ? (
          <SearchResults />
        ) : (
          <Box
            width="100%"
            textAlign="center"
            marginTop={12}
            color="text.secondary"
          >
            Your search results will show up here. <br />
            Please enter search criteria.
          </Box>
        )}
      </div>
    </Box>
  );
};

export default SearchOrchestrator;
